/**
 * This is for backwards-compatibility with existing projects, to avoid running code mods.
 */

import property from "../property";

export default property;
